import { notifyApp } from "@/composables/notifyComposable"
import { Api } from "@/api/Api"
import { useRouter } from "vue-router"
import { apiCustom } from "@/composables/apiCustomComposable"
import { validationForm } from "@/composables/validationFormComposable"
import { useStore } from "vuex"
export function loginCustom() {

     const {Message} = notifyApp()
        const {api} = apiCustom()
        const {ValidationForm} = validationForm()
        const router = useRouter()
        const store = useStore()
          async function login(body) {
            let result = {}
            if (!localStorage.lDM) {
                result = ValidationForm(body, ['email', 'password'])
            }
            if (!result?.isErro || localStorage.lDM) {
                const { mess, status, response } = await api('post', 'auth/signin', body)
                mess.forEach(m => Message(status, m))
                if (status === 'positive') {
                    Api.defaults.headers.common["Authorization"] = `Bearer ` + response.token;
                    localStorage.token = response?.token;
                    if (body.lDM) {
                        localStorage.lDM = response?.user.id
                        localStorage.date = new Date().toLocaleDateString('pt-br')
                    }
                    store.commit('setUser', response.user)
                    store.commit('setAuth', true)
                    await router.push('/findRegistration')
                }
            } if (result?.isErro) {
                Message(result?.type, result?.message)
            }
        }
        
    return {
        login
    }
}